import React, { PureComponent } from 'react';
import { Row, Col, Table, Button, Glyphicon } from 'react-bootstrap';

class BannersList extends PureComponent {
  onPressAction = (bannerId) => {
    this.props.viewHandle(bannerId);
  }

  render() {
    return (
      <div>
        <h1 className="main-title">Banners</h1>
        <Row>
          <Col sm={12}>
            <div className="text-right">
              <div
                onClick={this.props.createBanner}
                className="edit-link"
              >
                <span
                  className="new-link-btn"
                >
                  Add Banner
                </span>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col sm={12}>
            <Table className="links-table">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>Appearance Period</th>
                  <th>Status</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {this.props.list.map((item, index) => (
                  <tr>
                    <td style={{ minWidth: '200px' }}>{item.title}</td>
                    <td>{item.first_date} - {item.last_date}</td>
                    <td>{item.status}</td>
                    <td style={{ minWidth: '50px' }}>
                      <Button
                        style={{ border: 'none' }}
                        onClick={() => this.onPressAction(item.id)}
                      >
                        <Glyphicon glyph="search" />
                      </Button>

                      { (item.status === "Draft" || item.status === "Expired") 
                        && (+localStorage.getItem('userId') === item.created_by) 
                        && <Button
                            onClick={() => this.props.editHandle(item.id)}
                            style={{ border: 'none' }}
                          >
                            <Glyphicon glyph="pencil" />
                          </Button>
                      }
                      { item.status === "Draft" &&
                          <Button
                            onClick={() => this.props.deleteHandle(item.id, item.title)}
                            style={{ border: 'none' }}
                          >
                            <Glyphicon glyph="trash" />
                          </Button>
                      }
                      {
                        item.status === "Published" && +localStorage.getItem('roleId') === 1 &&
                        <Button
                          style={{ border: 'none' }}
                          onClick={() => this.props.hideHandle(item.id, item.hidden, item.title)}
                        >
                          <Glyphicon glyph={(item.hidden === 0 ? "eye-open" : "eye-close")} />
                        </Button>
                      }
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    )
  }

}

export default BannersList;


// WEBPACK FOOTER //
// ./src/app/screens/banners/bannersList.js